import PropTypes from "prop-types";
import MaximizeIcon from "../../assets/images/Maximise.png";

const ChatBar = props => {
  if (props.show === false) {
    return null;
  }

  return (
    <button
      id="chat-bar-button"
      className={"light-red-gradient"}
      onClick={props.onClick}
    >
      Chat about this delivery
      <img alt="Maximize Chat" src={MaximizeIcon} />
    </button>
  );
};

ChatBar.propTypes = {
  show: PropTypes.bool,
  businessUnit: PropTypes.number,
  onClick: PropTypes.func,
};

export default ChatBar;
